import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, _, u ) => {
	return {
		analyticsRoot: {
			padding       : "2rem",
			// height        : "100%",
			borderRadius  : "inherit",
			display       : "flex",
			flexDirection : "column",
			gap           : "2rem"
		},
		headerDiv: {
			display        : "flex",
			justifyContent : "space-between"
		},
		contentDiv: {
			gap            : "12rem",
			flex           : "1",
			display        : "flex",
			justifyContent : "flex-start",
			alignItems     : "end",
			flexWrap       : "none",

			[u.smallerThan ( "sm" )]: {
				display             : "grid",
				gridTemplateColumns : "repeat(2, 1fr)",
				justifyContent      : "flex-start",
				gap                 : "2rem"
			}
		},
		footer: {
			color: `${ theme.other.paletteNew.primaryDarkBlue } !important`
		},
		title: {
			fontWeight : "500",
			fontSize   : "1.6rem"

		}
	};
} );
